import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import EmployeeManagement from "@/pages/EmployeeManagement";
export const Route = createFileRoute("/employee-management")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><EmployeeManagement /></ProtectedRoute>) });
